import { render, staticRenderFns } from "./FullCategories.vue?vue&type=template&id=5db78d26&scoped=true"
import script from "./FullCategories.vue?vue&type=script&lang=js"
export * from "./FullCategories.vue?vue&type=script&lang=js"
import style0 from "./FullCategories.vue?vue&type=style&index=0&id=5db78d26&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db78d26",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5db78d26')) {
      api.createRecord('5db78d26', component.options)
    } else {
      api.reload('5db78d26', component.options)
    }
    module.hot.accept("./FullCategories.vue?vue&type=template&id=5db78d26&scoped=true", function () {
      api.rerender('5db78d26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/pages/custom/prione/FullCategories.vue"
export default component.exports